/*
 *###############################################################################
 *Module Name                   : StockFreezeProducts.js                        #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  T A C Priyashad                              #
 *Date                          : Tuesday, March 2th 2022, 8:18:08 am           #
 *Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)                         #
 *###############################################################################
 */

import React, { useState, useEffect } from 'react'
import { useContext } from 'react';
import ReactPaginate from "react-paginate"
import { Col, Row } from "reactstrap"
import { Context } from '../../../app-contexts/CommonContexts';

const StockFreezeProducts = ({ DataRow }) => {

  useEffect(() => {
    setPage(1)
  }, [DataRow])

  const [page, setPage] = useState(1)
  const [postsPerPage] = useState(10)


  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };



  const indexOfLastPost = page * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)


  return (
    <React.Fragment>
      <Row>
        <Col
          sm={12}
          md={8}
          className="mb-12-sm"
        >
          <table className="table table-bordered table-striped table-sm" style={{ fontSize: "11px" }} id={"GroupDet"}>
            <thead>
              <tr>
                <th style={{ width: "60px" }}>Line No</th>
                <th>Code </th>
                <th>Stock Code</th>
                <th>Description </th>
                <th style={{ textAlign: 'right' }}>Cost</th>
                <th style={{ textAlign: 'right' }}>Sell</th>

              </tr>
            </thead>
            <tbody>
              {(currentPosts || []).map((item, key) => (
                <TableRow FormRow={item} indexOfFirstPost={indexOfFirstPost} Key={key} />
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
      <Row>
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          pageCount={Math.ceil(DataRow.length / postsPerPage)}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          forcePage={page - 1}
          renderOnZeroPageCount={null}
          activeClassName={'active'}
          activeLinkClassName={'page-link'}
          containerClassName={'pagination justify-content-center pagination-sm'}
        />
      </Row>
    </React.Fragment>
  )
}

export default StockFreezeProducts

const TableRow = ({ FormRow, indexOfFirstPost, Key }) => {
  const {
    isHeadOffice, getMenuDetails, txnDecimalAmt, txnDecimalQty
  } = useContext(Context);
  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "50px" }}>{indexOfFirstPost + Key + 1}</td>
      <td style={{ width: "100px" }}>{FormRow.strPluCode}</td>
      <td style={{ width: "100px" }}>{FormRow.strPluStock}</td>
      <td style={{ width: "400px" }}>{FormRow.strPluDesc}</td>
      <td style={{ width: "80px", textAlign: 'right' }}>{parseFloat(FormRow.dcCost).toFixed(txnDecimalAmt)}</td>
      <td style={{ width: "80px", textAlign: 'right' }}>{parseFloat(FormRow.dcSell).toFixed(txnDecimalAmt)}</td>

    </tr>
  )
}
